import { render, staticRenderFns } from "./Pantalla.vue?vue&type=template&id=0eadee64&"
import script from "./Pantalla.vue?vue&type=script&lang=ts&"
export * from "./Pantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports